import React, { useEffect } from "react";
import "./Maps.css";
import Sidebar from "./components/Sidebar";
import Container from "@material-ui/core/Container";
import clsx from "clsx";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import { setToolbarPage } from "../../../Dashboard/actions/toolbar";
import { closeMenuOC } from "../../../Dashboard/actions/handleOpenCloseActions";
import FixedZero from "./routes_sidebar/FixedZero";
import FixedOpt from "./routes_sidebar/FixedOpt";
import InclOpt from "./routes_sidebar/InclOpt";
import TwoAxis from "./routes_sidebar/TwoAxis";
import WtModel1 from "./routes_sidebar/WtModel1";
import WtModel2 from "./routes_sidebar/WtModel2";
import WtModel3 from "./routes_sidebar/WtModel3";
import Windspeed from "./routes_sidebar/Windspeed";
import EmereGDP from "./routes_sidebar/EmereGDP";
import ConfigurationsMap from "./routes_sidebar/ConfigurationsMap";

export const Maps = ({
  open,
  classes,
  setToolbarPage,
  closeMenuOC,
  history,
}) => {
  useEffect(() => {
    setToolbarPage("Maps");
    closeMenuOC();
  }, []);
  return (
    <React.Fragment>
      <Sidebar></Sidebar>
      <main className={clsx(classes.content, !open && classes.contentShift)}>
        <div className={classes.appBarSpacer} />
        <Container

          className={classes.container}
          style={{ padding: 0, maxWidth: '100%' }}
        >
          <div style={{ height: "100vh" }}>
            <Route path="/dashboard/maps/fixed_zero">
              <FixedZero />
            </Route>
            <Route path="/dashboard/maps/fixed_optimal">
              <FixedOpt />
            </Route>
            <Route path="/dashboard/maps/inclined_optimal">
              <InclOpt />
            </Route>
            <Route path="/dashboard/maps/two_axis">
              <TwoAxis />
            </Route>
            <Route path="/dashboard/maps/wt_model_1">
              <WtModel1 />
            </Route>
            <Route path="/dashboard/maps/wt_model_2">
              <WtModel2 />
            </Route>
            <Route path="/dashboard/maps/wt_model_3">
              <WtModel3 />
            </Route>
            <Route path="/dashboard/maps/windspeed">
              <Windspeed />
            </Route>
            <Route path="/dashboard/maps/emere-gdp">
              <EmereGDP />
            </Route>
            <Route
              path="/dashboard/maps/configurations_map"
              render={(props) => <ConfigurationsMap {...props} />}
            ></Route>
          </div>
        </Container>
      </main>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  open: state.handleOpenClose.open,
});

export default connect(mapStateToProps, {
  setToolbarPage,
  closeMenuOC,
})(Maps);
